module.exports = __webpack_public_path__ + "logo_orange.png?372d9cb8e479457612d980a2dc137179";


//////////////////
// WEBPACK FOOTER
// ./src/img/confiance/logo_orange.png
// module id = 172
// module chunks = 0